import { render, staticRenderFns } from "./SolutionList.vue?vue&type=template&id=5ebe70af&scoped=true&"
import script from "./SolutionList.vue?vue&type=script&lang=js&"
export * from "./SolutionList.vue?vue&type=script&lang=js&"
import style0 from "./SolutionList.vue?vue&type=style&index=0&id=5ebe70af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe70af",
  null
  
)

export default component.exports